import { useEffect } from 'react'

import { getEnvironment } from '~/shared/helpers/getEnvironment'

const enum HOT_JAR_CLIENT_ID {
  PROD = '6380581',
  DEV = '6380733',
}

export const useHotJar = (): void => {
  const { isProdEnvironment } = getEnvironment()

  const clientID = isProdEnvironment
    ? HOT_JAR_CLIENT_ID.PROD
    : HOT_JAR_CLIENT_ID.DEV

  useEffect(() => {
    if (window.location.protocol !== 'https:') return

    if (typeof window.hj === 'function') return

    const loadHotJarScript = async () => {
      const script = document.createElement('script')
      script.async = true
      script.text = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${clientID},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
      document.body.appendChild(script)
    }

    loadHotJarScript()
  }, [clientID])
}
